import { AnchorLink } from 'gatsby-plugin-anchor-links';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { PortableTextWithHighlightDecorator } from 'src/components/PortableTextWithHighlightDecorator/PortableTextWithHighlightDecorator';
import { useLottieAnimation } from 'src/hooks/useLottieAnimation';
import { DesktopUp } from 'src/utils/breakpoints';
import * as styles from './CtaWithAnimation.module.scss';

function CtaWithAnimation({ pageType, ctaWithAnimation: { description, link, fallbackImage, animationData, isDark, isReverse } }) {
  const { Animation, FallbackImage } = useLottieAnimation({ fallbackImage, animationData });

  return (
    <div
      style={{ overflowX: 'clip' }}
      className={`${isDark ? ' bg-darker bg-shapes-cta-join-us' : ''} cta-container-${pageType} px-0 pt-8`}
    >
      <Container>
        <Row className={`${isReverse ? 'flex-lg-row-reverse' : ''}`}>
          <Col
            xs={{ span: 12, order: 0 }}
            lg={{ span: 6, order: 1 }}
            xl={{ span: 7 }}
            className="cta-container-animation mt-lg-n7 mb-lg-n6"
          >
            <div className={`cta-container-animation-inner ${isReverse ? 'ml-lg-n10' : 'mx-lg-n8'}`}>
              <div className={styles.animationContainer}>
                <div className={styles.animationWrapper}>
                  <div className={styles.fallback}>
                    <FallbackImage />
                  </div>

                  <DesktopUp>
                    <div className={styles.lottie}>
                      <Animation />
                    </div>
                  </DesktopUp>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={{ span: 10, order: 1 }}
            lg={{ span: 6, order: 0 }}
            xl={{ span: 5 }}
            className="z-index-2 cta-container-texts d-flex flex-column justify-content-center position-relative mt-lg-0 mt-6"
          >
            <div className={`${isDark ? styles.dark : styles.normal}`}>
              <PortableTextWithHighlightDecorator content={description} />
            </div>
            {link && (
              <div className="pt-4">
                <AnchorLink stripHash to={link?.url} className={`btn ${isDark ? 'btn-gradient-secondary' : 'btn-gradient-primary'}`}>
                  {link?.title ?? '[title]'}
                </AnchorLink>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CtaWithAnimation;
